
import { defineComponent, PropType } from 'vue'

// components
import Loader from '@/common/components/UI/Loader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { InvoiceHistoryStatusT } from '@/core/types/orders.types'

// enums
import { InvoiceStatusesEnum } from '@/core/enums/invoice.enums'

// icons
import checkIcon from '@/assets/icons/check.svg'

export default defineComponent({
    components: {
        Loader,
        TheButton,
        checkIcon,
    },
    props: {
        invoiceNumber: {
            type: String,
            default: null,
        },
        history: {
            type: Array as PropType<InvoiceHistoryStatusT[]>,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        failed: {
            type: Boolean,
            default: false,
        },
        deliveryTimeSlotTime: {
            type: String,
            defualt: null,
        },
        takeTimeSlotTime: {
            type: String,
            default: null
        }
    },
    emits: ['refresh'],
    setup(_, { emit }) {
        const emitRefresh = () => {
            emit('refresh')
        }

        const formatDate = (date: string, withTimeSlot: boolean) => {
            let date_first_part = null,
                date_second_part = null

            if (date) {
                let date_arr = date.split(' ')

                date_first_part = date_arr[0].split('.').reverse().join('.')
                date_second_part = date_arr[1]
            }

            if (date_first_part && date_second_part) {
                if (withTimeSlot) {
                    return date_first_part
                }
                
                return `${date_first_part} ${date_second_part}`
            } else {
                return '-'
            }
        }

        const formatTimeRange = (input: string): string => {
            const match = input.match(/(\d{2}):(\d{2}):(\d{2})\s*-\s*(\d{2}):(\d{2}):(\d{2})/)

            if (!match) {
                throw new Error("Неверный формат времени")
            }

            const splitted = input.split(' - ')

            const format = (timeStr: string) => timeStr.substring(0, 5)
            return `${format(splitted[0])} - ${format(splitted[1])}`
        }

        return { InvoiceStatusesEnum, emitRefresh, checkIcon, formatDate, formatTimeRange }
    },
})
